export default {
  presenter: 'pavlik',
  title: 'Spectre a Meltdown - jak fungují a co s nimi',
  subtitle: 'pokročilí/zkušení administrátoři/programátoři',
  text: `
Spectre a Meltdown otřásly světem a ten už nebude, jak jsme ho znali. Spekulativní vykonávání
instrukcí je jedním ze zásadních nástrojů pro dosažení vysokého výkonu procesorů, ale ukazuje se,
že je i šikovným nástrojem pro prolomení bezpečnostních opatření. Přednáška rozebere aspekty
architektury současných procesorů (branch prediction, speculative execution, register renaming, cache),
které Spectre a Meltdown využívají, ukáže jak fungují, kde hrozí jejich zneuzití (včetně JIT jako
JavaScript a eBPF) i jaká je proti nim možno přijmout opatření (spekulační bariéry, retpolíny,
IBRS/IBPB, KPTI/XPTI, ViXen/Comet).
  `,
}



// WEBPACK FOOTER //
// ./src/content/installfest/data/presentations/pavlik-spectre-meltdown.js